import React, { useState } from 'react';
import { Card, Container, Row, Col } from 'react-bootstrap';

import {
  AreaTitle,
  HeaderMessage,
  BottomMessage,
  ContainerBody,
  DebtMessageTime,
  BottomMessageAccess,
  CardHeader,
  CenterItemQuantity,
  CardBody,
  LimitText
} from "./styles";
import pix from '~/assets/images/pix.svg';
import copy from '~/assets/images/copy.svg';
import information from '~/assets/images/information-blue.svg'
import { formatDateTimeWithOffset } from '~/utils/utils';
import { useSelector } from 'react-redux';

export default function BodyPreviusPix({ order, pixData }) {
  const [copyValue, setCopyValue] = useState('Copiar chave PIX');
  const logisticPaymentReducer = useSelector(state => state.logisticPaymentReducer);

  function formatCurrency(value) {
    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  function copyToClipboard(text) {
    const inputElement = document.createElement('input');
    inputElement.value = text;
    document.body.appendChild(inputElement);
    inputElement.select();
    inputElement.setSelectionRange(0, 99999);
    document.execCommand('copy');
    document.body.removeChild(inputElement);
  }

  return(
    <ContainerBody>
      { pixData && (
        <>
          <AreaTitle>
            <img src={pix} alt="Debito no pedido" />
          </AreaTitle>
          <HeaderMessage>
            Pagamento via pix.
          </HeaderMessage>
          <HeaderMessage>
            {logisticPaymentReducer.order.netValue ? formatCurrency(logisticPaymentReducer.order.netValue) : formatCurrency(0)}
          </HeaderMessage>
          <BottomMessage>
            Copie a chave PIX e pague no aplicativo do seu banco.
          </BottomMessage>
          <Card.Header style={CardHeader}>
            <Container>
              <Row>
                <Col>
                  <CenterItemQuantity>
                    <LimitText>
                      {pixData && pixData[0]?.key ? pixData[0].key : ''}
                    </LimitText>
                  </CenterItemQuantity>
                </Col>
              </Row>
              <CardBody>
                <Col className="d-flex align-items-center justify-content-center" onClick={(e) => { setCopyValue('Copiado!'); copyToClipboard(pixData && pixData[0]?.key ? pixData[0].key : ''); }} style={{ cursor: 'pointer' }}>
                  <img src={copy} alt="Debito no pedido" />
                  <CenterItemQuantity>{ copyValue }</CenterItemQuantity>
                </Col>
              </CardBody>
            </Container>
          </Card.Header>
          {order?.expirationDate && (
            <>
              <DebtMessageTime>
                <img src={information} alt="info no pedido" /> {`Pedido disponível até ${order.expirationDate ? formatDateTimeWithOffset(order.expirationDate) : order.expirationDate}, horário de Brasília.`}
              </DebtMessageTime>
              <BottomMessageAccess>
                Caso o pagamento não seja identificado até esse horário, o pedido será cancelado
              </BottomMessageAccess>
            </>
          )}
        </>
      )}
      {!pixData && (
         <>
          <HeaderMessage>
            Não foi possível gerar a chave PIX.
          </HeaderMessage>
          <BottomMessage>
            O seu pedido foi processado, mas tivemos um problema para gerar a chave PIX
          </BottomMessage>
          <BottomMessage>
           Entre em contato com o SAP Local para efetuar o pagamento ou nos envie o comprovante de pagamento para analisarmos.
          </BottomMessage>
          {order?.expirationDate && (
            <>
            <DebtMessageTime>
              <img src={information} alt="info no pedido" /> {`Pedido disponível até ${order.expirationDate ? formatDateTimeWithOffset(order.expirationDate) : order.expirationDate}, horário de Brasília.`}
            </DebtMessageTime>
            <BottomMessageAccess>
              Caso o pagamento não seja identificado até esse horário, o pedido será cancelado
            </BottomMessageAccess>
            </>
          )}

        </>
      )}
    </ContainerBody>
  );
}
